document.addEventListener("DOMContentLoaded", function () {

  let cartOpening = false;

  function openCartDrawer() {

    if(cartOpening) return;

    cartOpening = true;

    const toggle = document.querySelector('.offcanvas-toggle');

    if (toggle) {
      toggle.click();
    }

    setTimeout(function(){
      cartOpening = false;
    },1000);
  }

  if (window.jQuery) {

    jQuery(document).ajaxComplete(function(event, xhr, settings) {

      if (settings.url.includes('/cart/add')) {

        setTimeout(function(){
          openCartDrawer();
        }, 300);

      }

    });

  }

});